import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Form, Button } from 'react-bootstrap'
// import RenderInput from './FormFields/RenderInput'
import RenderSelect from './FormFields/RenderSelect'
import SingleDatePickerWrapper from './FormFields/SingleDatePickerWrapper'
import moment from 'moment';
import '../../../stylesheets/FilterForm.css';

class FilterForm extends React.Component {

  submit(data) {
    this.props.saveFilterOptions(data);
  }

  handleDurationChange(event){
    let duration = this._findDuration(event.target.value)
    let toDate = moment();
    let fromDate = moment().subtract(duration,'d');
    this.props.change('from_date', fromDate.format('DD-MM-YYYY'))
    this.props.change('to_date', toDate.format('DD-MM-YYYY'))
  }

  _findDuration(val) {
    if(typeof val === 'number') {
      return val
    }else if(typeof val === 'string') {
      switch(val) {
        case '3 Months':
          return 90;
        case '6 Months':
          return 180;
        case '1 Year':
          return 365;
        case 'Overall':
          let oldDate = moment("2000-01-01", "YYYY-MM-DD");
          let current = moment().startOf('day');
          return Math.abs(moment.duration(oldDate.diff(current)).asDays());
        default:
          return val;
      }
    }
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, teams } = this.props

    // duration filter options
    let days = [7,10,20,30].map(a => {
      return {id: a, name: `${a} Days`}
    });

    // more filter options
    ['3 Months', '6 Months', '1 Year', 'Overall'].map(a => {
      days.push({id: a, name: a})
    })

    return (
      <div className="FilterForm">
        <Form onSubmit={handleSubmit(this.submit.bind(this))} inline>
          <span >Filter by: </span>
          <Field name='team_id' component={RenderSelect} options={teams} className='team_id' title='Team' />
          <Field name='duration' component={RenderSelect} options={days} onChange={this.handleDurationChange.bind(this)} title="Last (n) days" />
          <Field
            name='from_date'
            component={SingleDatePickerWrapper}
            title="From Date"
          />
          <Field
            name='to_date'
            component={SingleDatePickerWrapper}
            title="To Date"
          />
          <Button type="submit" disabled={pristine || submitting} className='btn-primary submit-btn'>{submitting ? 'Filtering' : 'Filter'}</Button>
        </Form>
      </div>
    )
  }
}

export default reduxForm({
  form: 'reportsFilter'
})(FilterForm)


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/components/User/FilterForm.jsx